var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-search",class:{ design: _vm.isDesignActive }},[_c('div',{ref:"search-bar-banner",staticClass:"w-100 text-center"},[_c('SearchBar',{attrs:{"is-banner":true,"show-wrapper-border":_vm.isDesignActive}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }